
import { useLanguage } from '../../../contexts/LanguageContext';
import { translations } from '../../../mocks/translations';

export default function LicenseInfo() {
  const { language } = useLanguage();
  const t = translations[language].license;

  return (
    <div className="space-y-8">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold text-gray-900 mb-4">{t.title}</h2>
        <p className="text-lg text-gray-600">{t.subtitle}</p>
      </div>

      {/* License Banner Image */}
      <div className="relative h-48 lg:h-56 rounded-2xl overflow-hidden mb-8">
        <img 
          src="https://public.readdy.ai/ai/img_res/a10bd46df6fad347417e8e5c1a7132f6.jpg"
          alt="Business License"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-teal-900/80 to-teal-900/40"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center">
            <div className="inline-flex items-center gap-3 px-6 py-3 bg-white/10 backdrop-blur-sm rounded-full border border-white/20 mb-4">
              <i className="ri-verified-badge-line text-2xl text-teal-300"></i>
              <span className="text-white font-bold text-lg">License No. 5037142</span>
            </div>
            <p className="text-white/80 text-sm">Officially Registered in RAK Free Zone</p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div className="bg-gradient-to-br from-teal-50 to-white p-8 rounded-xl border border-teal-100 hover:shadow-lg transition-shadow">
          <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mb-4">
            <i className="ri-file-text-line text-2xl text-teal-600"></i>
          </div>
          <h3 className="text-sm font-medium text-gray-500 mb-2">{t.licenseNumber}</h3>
          <p className="text-2xl font-bold text-gray-900">5037142</p>
        </div>

        <div className="bg-gradient-to-br from-emerald-50 to-white p-8 rounded-xl border border-emerald-100 hover:shadow-lg transition-shadow">
          <div className="w-12 h-12 flex items-center justify-center bg-emerald-100 rounded-lg mb-4">
            <i className="ri-building-line text-2xl text-emerald-600"></i>
          </div>
          <h3 className="text-sm font-medium text-gray-500 mb-2">{t.type}</h3>
          <p className="text-2xl font-bold text-gray-900">{t.freezone}</p>
        </div>

        <div className="bg-gradient-to-br from-teal-50 to-white p-8 rounded-xl border border-teal-100 hover:shadow-lg transition-shadow">
          <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mb-4">
            <i className="ri-bookmark-line text-2xl text-teal-600"></i>
          </div>
          <h3 className="text-sm font-medium text-gray-500 mb-2">{t.licenseCode}</h3>
          <p className="text-2xl font-bold text-gray-900">CWEP0549</p>
        </div>

        <div className="bg-gradient-to-br from-emerald-50 to-white p-8 rounded-xl border border-emerald-100 hover:shadow-lg transition-shadow">
          <div className="w-12 h-12 flex items-center justify-center bg-emerald-100 rounded-lg mb-4">
            <i className="ri-calendar-check-line text-2xl text-emerald-600"></i>
          </div>
          <h3 className="text-sm font-medium text-gray-500 mb-2">{t.issueDate}</h3>
          <p className="text-2xl font-bold text-gray-900">05-02-2026</p>
        </div>

        <div className="bg-gradient-to-br from-orange-50 to-white p-8 rounded-xl border border-orange-100 hover:shadow-lg transition-shadow">
          <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-lg mb-4">
            <i className="ri-calendar-event-line text-2xl text-orange-600"></i>
          </div>
          <h3 className="text-sm font-medium text-gray-500 mb-2">{t.expiryDate}</h3>
          <p className="text-2xl font-bold text-gray-900">04-02-2027</p>
        </div>

        <div className="bg-gradient-to-br from-teal-50 to-white p-8 rounded-xl border border-teal-100 hover:shadow-lg transition-shadow">
          <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mb-4">
            <i className="ri-shield-check-line text-2xl text-teal-600"></i>
          </div>
          <h3 className="text-sm font-medium text-gray-500 mb-2">{t.status}</h3>
          <p className="text-2xl font-bold text-gray-900">{t.active}</p>
        </div>
      </div>

      <div className="mt-8 p-6 bg-teal-50 border border-teal-200 rounded-xl">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 flex items-center justify-center bg-teal-600 rounded-lg flex-shrink-0">
            <i className="ri-information-line text-xl text-white"></i>
          </div>
          <div>
            <h4 className="text-lg font-bold text-gray-900 mb-2">{t.verificationTitle}</h4>
            <p className="text-sm text-gray-700 leading-relaxed">
              {t.verificationDescription}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
